import {
  Button,
  Card,
  Col,
  Form,
  Image,
  Modal,
  Row,
  Switch,
  Tag,
  Tooltip,
  Typography,
  InputNumber
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  DisconnectOutlined,
  DownloadOutlined,
  LoadingOutlined,
  PlayCircleOutlined,
  ReloadOutlined,
  SettingOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  createEvolutionInstance, deleteEvolutionInstance, getEvolutionInstance, getEvolutionById, updateEvolutionInstance
} from "../../services/evolution";

import { toast } from 'sonner'
export default function EvolutionIntegration({ icon, label, assistantID }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);

  const [form] = Form.useForm();
  const [installForm] = Form.useForm();
  const onlyWithoutTag = Form.useWatch('onlyWithoutTag', form);
  const onlyWithTags = Form.useWatch('onlyWithTags', form);

  useEffect(() => {
    setLoading(true)
    getEvolutionInstance({ assistantID }).then(({ data }) => {
      if (data.length === 0) return
      setData(data[0])
    }).catch((error) => {
      console.log(error)
      toast.error("Erro ao buscar integração com site.");
    }).finally(() => {
      setLoading(false)
    });
  }, [assistantID])

  const [syncContactsModal, setSyncContactsModal] = useState(false);

  const install = useCallback(async (values) => {
    setButtonLoading(true)
    await createEvolutionInstance({
      assistantID: parseInt(assistantID),
      onlyWithoutTag: false,
      active: true,
      ...values
    }).then(({ data }) => {
      setData(data);
    }).catch((error) => {
      console.log(error);
      toast.error("Erro ao instalar integração com Evolution.");
    }).finally(() => {
      setButtonLoading(false);
      setSyncContactsModal(false)
    });
  }, [assistantID]);

  const uninstall = useCallback(async () => {
    setButtonLoading(true);
    await deleteEvolutionInstance(data.id).then(() => {
      setData(undefined);
    }).catch((error) => {
      console.log(error);
      toast.error("Erro ao remover integração com Evolution.");
    }).finally(() => {
      setButtonLoading(false)
    });
  }, [data]);

  const update = useCallback(async (newData) => {
    setButtonLoading(true);
    await updateEvolutionInstance(data.id, { ...data, ...newData }).then(({ data: updatedData }) => {
      setData({ ...updatedData });
      setConfigOpen(false);
      toast.success("Atualizado com sucesso!");
    }).catch((error) => {
      console.log(error);
      toast.error("Erro ao atualizar.");
    }).finally(() => {
      setButtonLoading(false);
    });
  }, [data]);

  const save = useCallback(async (values) => {
    await form.validateFields().then(() => {
      update(values);
    }).catch((err) => {
      console.log(err)
    })

  }, [form, update]);

  const handleConfigOpen = () => {
    form.setFieldsValue(data);
    setConfigOpen(true);
  }

  const handleConfigClose = () => {
    form.resetFields()
    setConfigOpen(false)
  }

  return (<>
    <Modal
      title="Configurar Instalação"
      open={syncContactsModal}
      onCancel={() => setSyncContactsModal(false)}
      confirmLoading={buttonLoading}
      onOk={installForm.submit}
      okText={'Instalar'}
      cancelText={'Cancelar'}
    >
      <Form form={installForm} layout={'vertical'} onFinish={install}>
        <Form.Item
          label="Sincronizar contatos"
          name="syncContacts"
          valuePropName="checked"
          initialValue={false}
          help="Ao sincronizar os contatos, você poderá enviar mensagens para seus contatos diretamente pela plataforma."
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Ignorar grupos"
          name="groupsIgnore"
          valuePropName="checked"
          initialValue={false}
          help="O assistente não responderá a mensagens em grupos."
        >
          <Switch />
        </Form.Item>
        {/*
          TODO => backend
          <Form.Item
            label="Sincronizar histórico recente"
            name="syncRecentHistory"
            valuePropName="checked"
            help="Sincroniza o histórico recente de conversas."
          >
            <Switch/>
          </Form.Item>
      */}
      </Form>
    </Modal>
    <Modal title="Configurar Chat Externo"
      open={configOpen}
      cancelText={'Cancelar'}
      confirmLoading={buttonLoading}
      okText={'Salvar'}
      onOk={form.submit}
      onCancel={handleConfigClose}>
      <br />
      <Row gutter={[24]}>
        <Col span={24}>
          <Form layout={'vertical'} form={form} onFinish={save}>
            {/*<Form.Item label={'Responder com tags especificas'}*/}
            {/*  name={'onlyWithTags'}*/}
            {/*  valuePropName={"checked"}*/}
            {/*  help={'Responder apenas a contatos tiverem etiquetas especificas.'}*/}
            {/*  initialValue={false}>*/}
            {/*  <Switch disabled={onlyWithoutTag} />*/}
            {/*</Form.Item>*/}

            {/*{!onlyWithoutTag && <Form.Item label={'Tags'}*/}
            {/*  name={'tags'}*/}
            {/*  help={'Preencha caso deseje que que o bot só responda clientes com determinadas etiquetas.'}>*/}
            {/*  <Select*/}
            {/*    mode="tags"*/}
            {/*    style={{ width: '100%' }}*/}
            {/*    placeholder="Digite tags"*/}
            {/*    tokenSeparators={[',']}*/}
            {/*    open={false}*/}
            {/*  />*/}
            {/*</Form.Item>}*/}
            <Form.Item label={'Leitura automática'}
              name={'autoRead'}
              valuePropName={"checked"}
              help={'Ler todas as mensagens recebidas pelo assistente automaticamente'}
              initialValue={false}>
              <Switch />
            </Form.Item>
            <Form.Item label={'Responder a menções em grupos'}
              name={'enableGroupMention'}
              valuePropName={"checked"}
              help={'Responde quando alguem menciona ela em um grupo'}
              initialValue={false}>
              <Switch />
            </Form.Item>
            {/*<Form.Item label={'Definir tag quando enviado pelo app'}*/}
            {/*  name={'setTagFromApp'}*/}
            {/*  help={'Preencha caso deseje que o bot defina uma etiqueta quando alguem mandar uma mensagem atraves do app do whatsapp.'}>*/}
            {/*  <Input />*/}
            {/*</Form.Item>*/}
            <Form.Item label={'Ativar respostas'}
              name={'enableAnswer'}
              initialValue={true}
              help={'Deixa apenas copiloto ativo, o assistente não responde mais.'}>
              <Switch />
            </Form.Item>
            <Form.Item label={'Tempo aguardando Usuário digitar'}
                       name={'accumulateWait'}
                       initialValue={5}
                       help={'Aguarda o usuário digitar e acumula as mensagens enviadas. (A contagem inicia a partir da primeira mensagem)'}>
              <InputNumber min={0} max={60} />
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Modal>
    <Card
      loading={loading}
      title={<Typography.Title level={5} ellipsis={{ tooltip: label }}>{icon} {label}</Typography.Title>}
      extra={<Button type={data ? 'default' : 'primary'}
        loading={loading || buttonLoading}
        danger={!!data}
        onClick={() => data ? uninstall() : setSyncContactsModal(true)}
        icon={data ? <CloseOutlined /> : <DownloadOutlined />}
      >{loading ? undefined : data ? 'Remover' : 'Instalar'}</Button>}
      actions={data ? [<Tooltip title={'Em breve será possível desconectar'}>
        <DisconnectOutlined />
      </Tooltip>, <SettingOutlined onClick={handleConfigOpen} />] : undefined}>
      <Configuration setData={setData} data={data} />
    </Card>
  </>)
}

function Configuration({ data, setData }) {
  const [checking, setChecking] = useState(false);
  const isConnected = useMemo(() => data?.status?.instance?.state === 'open', [data?.status?.instance?.state]);

  useEffect(() => {
    if (!data?.id || data?.status?.instance?.state === 'open') return;

    let time = 5000;
    let limit = 40;
    let i = 0;
    const interval = setInterval(() => {
      setChecking(true)
      getEvolutionById(data.id).then(({ data }) => {
        setData(data);
        if (data?.status?.instance?.state === 'open') {
          clearInterval(interval);
          setChecking(false);
        }
      }).catch(e => {
        console.log(e);
        toast.error("Falha ao checar status");
      })

      i++;
      if (i > limit) clearInterval(interval);
    }, time)

    return () => clearInterval(interval);
  }, [data?.id, data?.status?.state]);

  const Disconnected = () => <Row justify={'center'} wrap>
    <Tag color={'error'} icon={<DisconnectOutlined />} style={{
      justifySelf: 'center', margin: 0, marginBottom: 12
    }}>{checking ? "Verificando..." : "Desconectado"} {checking && <LoadingOutlined />}</Tag>
    <Col span={24} />
    {data.pairingCode && (
      <Col span={24} style={{ textAlign: 'center', marginBottom: 12 }}>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>Código de pareamento</Typography.Text>
        <br />
        <Typography.Text copyable strong style={{ fontSize: 18, letterSpacing: 2 }}>{data.pairingCode}</Typography.Text>
      </Col>
    )}
    <Image src={data.qrCodeImage} height={150} />
  </Row>

  const Connected = () => <Typography.Text>
    Evolution configurada e operando normalmente
  </Typography.Text>

  if (!data) return <Typography>
    Configure o Whatsapp com sua instancia da Evolution.
  </Typography>

  return (<>{isConnected ? <Connected /> : <Disconnected />}</>)
}
